// Subscription components: bridge the app bulk-pricing form to the theme controls.
// This asset is loaded only by subscription product templates.
// App controls (.bulk-pricing-controls) are hidden on subscription templates;
// theme .flxwrap__qty + #sliderttl stay visible. Sync both directions.
// %kriz customize
// ============================================================
(function () {
  var SYNC_FLAG = 'data-subscription-syncing';
  var TARGET_TEMPLATE_CLASS = 'subscription-template';
  var TARGET_PRODUCT_TEMPLATE_CLASSES = [
    'trio-gloves-subscription',
    'adrelate-gloves-subscription',
    'product-subscription'
  ];
  var TARGET_SECTION_CLASSES = ['subscription-product-section'];
  var initialized = false;
  var bodyHasNativeTargetTemplate = false;
  var activeTargetProductId = null;
  var deliveryGroupCounter = 0;

  function getTargetSection(productId) {
    var resolvedProductId = productId || activeTargetProductId;
    var productIdSelector = resolvedProductId
      ? '[data-product-id="' + String(resolvedProductId).replace(/"/g, '\\"') + '"]'
      : '';

    for (var index = 0; index < TARGET_SECTION_CLASSES.length; index += 1) {
      var section = document.querySelector(
        '.product-section.' + TARGET_SECTION_CLASSES[index] + productIdSelector
      );
      if (section) return section;
    }

    if (isTargetTemplate()) {
      return document.querySelector('.product-section' + productIdSelector);
    }

    return null;
  }

  function isTargetTemplate() {
    var body = document.body;
    if (!body) return false;
    return (
      body.classList.contains(TARGET_TEMPLATE_CLASS) &&
      !!document.querySelector('.subscription-product-section .subscription-pdp')
    );
  }

  function isProductSubscriptionTemplate() {
    if (document.body && document.body.classList.contains('product-subscription')) return true;
    var section = getTargetSection();
    return !!(
      section &&
      section.getAttribute('data-product-template') === 'product-subscription'
    );
  }

  function ensureSubscriptionTemplateClass() {
    if (!document.body) return;
    if (document.querySelector('.subscription-product-section .subscription-pdp')) {
      document.body.classList.add(TARGET_TEMPLATE_CLASS);
    }
  }

  function getBulkForm() {
    var section = getTargetSection();
    if (!section) return null;
    return section.querySelector('.subscription-pdp bulk-pricing-form');
  }

  function getThemeQtyInput() {
    var section = getTargetSection();
    if (!section) return null;
    return section.querySelector(
      '.subscription-pdp .flxwrap__qty .sliderqty, .subscription-pdp .flxwrap__qty .js-qty__num'
    );
  }

  function getThemeTotalInput() {
    var section = getTargetSection();
    return section ? section.querySelector('#sliderttl, #sliderttl-modal') : null;
  }

  function getAppQtyInput(form) {
    if (!form) return null;
    return form.querySelector('#bulk-pricing-quantity, bulk-pricing-qty-input input[name="quantity"]');
  }

  function getActiveRow(form) {
    if (!form) return null;
    return form.querySelector('tbody tr.bulk-pricing-table__row--active, tr.bulk-pricing-table__row--active');
  }

  function getEffectiveUnitCents(row, form) {
    if (!row) return 0;
    if (form && typeof form.getEffectiveTierPrice === 'function') {
      var fromApp = form.getEffectiveTierPrice(row);
      if (fromApp || fromApp === 0) return parseFloat(fromApp) || 0;
    }

    var selectedOption = form
      ? form.querySelector('input[name="bulk-pricing-purchase-option"]:checked')
      : null;
    var isSubscription = selectedOption && selectedOption.value === 'subscription';

    if (isSubscription) {
      var subAttr = Array.prototype.find.call(row.attributes || [], function (attr) {
        return /^data-tier-sub-.*-price$/.test(attr.name);
      });
      if (subAttr) {
        var subPrice = parseFloat(subAttr.value);
        if (!isNaN(subPrice)) return subPrice;
      }
    }

    return parseFloat(row.getAttribute('data-tier-price')) || 0;
  }

  function formatThemeMoney(cents) {
    var amount = Math.round(Number(cents) || 0);
    if (document.body && document.body.classList.contains('product-subscription')) {
      return '$' + (amount / 100).toFixed(2);
    }
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      var moneyFormat =
        (theme.settings && theme.settings.moneyFormat) ||
        (window.theme && theme.moneyFormat) ||
        '${{amount}}';
      return theme.Currency.formatMoney(amount, moneyFormat);
    }
    return '$' + (amount / 100).toFixed(2);
  }

  function normalizeSubscriptionCurrency() {
    if (!document.body || !document.body.classList.contains('product-subscription')) return;
    var section = getTargetSection();
    if (!section) return;

    section
      .querySelectorAll('.subscription-pdp .product__price, .subscription-pdp bulk-pricing-form')
      .forEach(function (container) {
        var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
        var textNodes = [];
        while (walker.nextNode()) textNodes.push(walker.currentNode);
        textNodes.forEach(function (node) {
          node.nodeValue = node.nodeValue.replace(/CA\$/g, '$').replace(/CAD\s*\$?/g, '$');
        });
      });
  }

  function updateThemeTotal(qty, unitCents) {
    var totalInput = getThemeTotalInput();
    if (!totalInput) return;
    totalInput.value = formatThemeMoney(qty * unitCents);
  }

  function setThemeQuantity(qty) {
    var themeQty = getThemeQtyInput();
    if (!themeQty) return;

    document.documentElement.setAttribute(SYNC_FLAG, '1');
    themeQty.value = String(qty);

    var floatingQty = document.getElementById('floating-Quantity');
    if (floatingQty) floatingQty.value = String(qty);

    // Clear flag after theme generic total handlers run, then re-apply bulk total
    window.setTimeout(function () {
      document.documentElement.removeAttribute(SYNC_FLAG);
    }, 0);
  }

  function getBasePriceCents(form) {
    var table = form && form.querySelector('bulk-pricing-table');
    if (table && table.hasAttribute('data-base-price')) {
      return parseFloat(table.getAttribute('data-base-price')) || 0;
    }
    var baseEl = form && form.querySelector('[data-base-price]');
    if (baseEl) return parseFloat(baseEl.getAttribute('data-base-price')) || 0;
    // Fallback: first row one-time tier (cents)
    var firstRow = form && form.querySelector('tr.bulk-pricing-table__row[data-tier-price]');
    return firstRow ? parseFloat(firstRow.getAttribute('data-tier-price')) || 0 : 0;
  }

  function updateThemeSavings(qty, unitCents, form) {
    var baseCents = getBasePriceCents(form);
    var savingsCents = Math.max(0, qty * baseCents - qty * unitCents);
    var formatted = formatThemeMoney(savingsCents);
    var section = getTargetSection();
    if (!section) return;

    var savedEl = section.querySelector('.qty-table-saved-amount');
    if (savedEl) savedEl.innerText = formatted;

    var savdTotal = section.querySelector('#savdtotal, #savdtotal-modal');
    if (savdTotal) {
      if (savingsCents > 0) {
        savdTotal.textContent = 'You save ' + formatted + ' over minimum quantity pricing';
      } else {
        savdTotal.textContent = '';
      }
    }
  }

  function syncThemeFromRow(row) {
    if (!row || !row.hasAttribute('data-qty')) return;

    var form = getBulkForm();
    var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
    var unitCents = getEffectiveUnitCents(row, form);

    setThemeQuantity(qty);
    updateThemeTotal(qty, unitCents);
    updateThemeSavings(qty, unitCents, form);

    // Re-assert total after theme.js updateGenericTotalCost (variant.price * qty)
    window.setTimeout(function () {
      updateThemeTotal(qty, unitCents);
      updateThemeSavings(qty, unitCents, form);
    }, 30);
    window.setTimeout(function () {
      updateThemeTotal(qty, unitCents);
      updateThemeSavings(qty, unitCents, form);
    }, 120);
  }

  function syncFromThemeQuantity() {
    if (document.documentElement.getAttribute(SYNC_FLAG) === '1') return;

    var form = getBulkForm();
    if (!form) return;

    var table = form.querySelector('bulk-pricing-table');
    var themeQty = getThemeQtyInput();
    if (!table || !themeQty) return;

    var qty = parseInt(themeQty.value, 10) || 1;
    if (qty < 1) qty = 1;

    var appQty = getAppQtyInput(form);
    if (appQty && String(appQty.value) !== String(qty)) {
      appQty.value = String(qty);
      appQty.dispatchEvent(new Event('input', { bubbles: true }));
      appQty.dispatchEvent(new Event('change', { bubbles: true }));
      // Prefer the app's custom event if present
      form.dispatchEvent(
        new CustomEvent('quantity-change', {
          bubbles: true,
          detail: { quantity: qty },
        })
      );
    }

    if (typeof table.updateActiveRow === 'function') {
      table.updateActiveRow(qty);
    } else {
      var matchingRow = null;
      form.querySelectorAll('tr.bulk-pricing-table__row[data-qty]').forEach(function (row) {
        var rowQty = parseInt(row.getAttribute('data-qty'), 10) || 1;
        if (rowQty <= qty) matchingRow = row;
        row.classList.remove('bulk-pricing-table__row--active');
      });
      if (matchingRow) matchingRow.classList.add('bulk-pricing-table__row--active');
    }

    var activeRow = getActiveRow(form);
    var unitCents = getEffectiveUnitCents(activeRow, form);
    updateThemeTotal(qty, unitCents);
    updateThemeSavings(qty, unitCents, form);

    if (typeof form.updatePriceFromInput === 'function') {
      form.updatePriceFromInput(qty);
    }
    if (typeof form.updateText === 'function') {
      form.updateText();
    }
  }

  function onPricingTableSelect(event) {
    var row =
      (event.target && event.target.closest && event.target.closest('tr.bulk-pricing-table__row')) ||
      event.target;
    if (!row || !row.getAttribute || !row.hasAttribute('data-qty')) return;
    syncThemeFromRow(row);
  }

  function getSelectedPurchaseOption(form) {
    var checked = form
      ? form.querySelector('input[name="bulk-pricing-purchase-option"]:checked')
      : null;
    return checked ? checked.value : 'onetime';
  }

  function getDeliveryPlans(form) {
    if (!form) return [];

    var cadenceMapScript = form.querySelector('script[data-selling-plan-cadence-map="true"]');
    var cadenceByPlanId = {};

    if (cadenceMapScript) {
      try {
        var parsed = JSON.parse(cadenceMapScript.textContent || '{}');
        cadenceByPlanId = parsed.bySellingPlanId || {};
      } catch (error) {
        cadenceByPlanId = {};
      }
    }

    function getDeliveryLabel(planName, cadenceKey) {
      var normalizedName = String(planName || '').replace(/\s+/g, ' ').trim();
      var nameMatch = normalizedName.match(/\bEvery\s+(.+)$/i);
      if (nameMatch) return nameMatch[1].trim();

      var cadenceMatch = String(cadenceKey || '')
        .toLowerCase()
        .match(/^(\d+)([dwmy])$/);
      if (cadenceMatch) {
        var amount = parseInt(cadenceMatch[1], 10);
        var units = { d: 'day', w: 'week', m: 'month', y: 'year' };
        return amount + ' ' + units[cadenceMatch[2]] + (amount === 1 ? '' : 's');
      }

      return normalizedName || String(cadenceKey || '');
    }

    var plans = [];
    var seenPlanIds = {};

    function addPlan(planId, cadenceKey, planName) {
      var normalizedPlanId = String(planId || '');
      if (!normalizedPlanId || seenPlanIds[normalizedPlanId]) return;

      var normalizedCadence = String(
        cadenceKey || cadenceByPlanId[normalizedPlanId] || normalizedPlanId
      ).toLowerCase();
      var normalizedName = String(planName || '').replace(/\s+/g, ' ').trim();

      seenPlanIds[normalizedPlanId] = true;
      plans.push({
        key: normalizedCadence,
        label: getDeliveryLabel(normalizedName, normalizedCadence),
        planName: normalizedName,
        planId: normalizedPlanId,
      });
    }

    // Prefer the controls rendered by the app. Unlike the cadence map, these
    // contain only the delivery plans the app has actually enabled.
    var select = form.querySelector('.bulk-pricing-selling-plan-select');
    if (select) {
      Array.prototype.forEach.call(select.options || [], function (option) {
        if (!option.value || option.disabled) return;
        addPlan(
          option.value,
          option.getAttribute('data-cadence-key'),
          option.textContent
        );
      });
      if (plans.length) return plans;
    }

    var singleInput = form.querySelector('.bulk-pricing-selling-plan-input');
    var singlePlanId = singleInput
      ? singleInput.getAttribute('data-single-plan-id') || singleInput.value
      : '';
    if (singlePlanId) {
      var singleLabel = form.querySelector('.bulk-pricing-selling-plan-single');
      addPlan(
        singlePlanId,
        singleInput.getAttribute('data-single-plan-cadence-key'),
        singleLabel ? singleLabel.textContent : ''
      );
      return plans;
    }

    // The app's JS config may be ready just before its native controls mount.
    // It is still authoritative; the Shopify cadence map alone is never used.
    var table = form.querySelector('bulk-pricing-table');
    var configuredPlans =
      table && table.bulkPricingConfig && Array.isArray(table.bulkPricingConfig.sellingPlans)
        ? table.bulkPricingConfig.sellingPlans
        : [];
    configuredPlans.forEach(function (plan) {
      addPlan(plan.id, plan.cadenceKey, plan.name);
    });

    return plans;
  }

  function setDeliveryCadence(form, cadenceKeyOrPlanId, notifyApp) {
    if (!form) return;
    var plans = getDeliveryPlans(form);
    var plan = plans.find(function (item) {
      return item.key === cadenceKeyOrPlanId || item.planId === cadenceKeyOrPlanId;
    });
    if (!plan) return;

    var select = form.querySelector('.bulk-pricing-selling-plan-select');
    var sellingPlanInput = form.querySelector('.bulk-pricing-selling-plan-input');

    if (select) {
      var option = Array.prototype.find.call(select.options, function (item) {
        return String(item.value) === plan.planId;
      });
      if (option) select.value = plan.planId;
    }

    if (sellingPlanInput) {
      sellingPlanInput.setAttribute('data-single-plan-id', plan.planId);
      sellingPlanInput.setAttribute('data-single-plan-cadence-key', plan.key);
      sellingPlanInput.value = plan.planId;
      sellingPlanInput.disabled = false;
    }

    form.setAttribute('data-subscription-delivery-cadence', plan.key);
    form.querySelectorAll('input[name^="subscription-delivery-frequency-"]').forEach(function (input) {
      input.checked = input.getAttribute('data-selling-plan-id') === plan.planId;
    });

    if (notifyApp && select) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function ensureDeliveryOptions(form) {
    if (!form) return;
    var plans = getDeliveryPlans(form);

    var controls = form.querySelector('.bulk-pricing-subscription-controls');
    if (!controls) return;

    var deliveryOptions = controls.querySelector('.subscription-delivery-options');
    if (!plans.length) {
      if (deliveryOptions) deliveryOptions.remove();
      form.removeAttribute('data-subscription-delivery-cadence');
      return;
    }

    var nativeFrequencyWrap = controls.querySelector('.bulk-pricing-subscription-frequency-wrap');
    var nativeSingleFrequency = controls.querySelector('.bulk-pricing-selling-plan-single');
    if (nativeFrequencyWrap) nativeFrequencyWrap.style.setProperty('display', 'none', 'important');
    if (nativeSingleFrequency) nativeSingleFrequency.style.setProperty('display', 'none', 'important');

    if (!deliveryOptions) {
      deliveryGroupCounter += 1;
      deliveryOptions = document.createElement('div');
      deliveryOptions.className = 'subscription-delivery-options';
      deliveryOptions.setAttribute('role', 'group');
      deliveryOptions.setAttribute('aria-label', 'Delivery frequency');

      var title = document.createElement('span');
      title.className = 'subscription-delivery-options__title';
      title.textContent = 'Deliver every';
      deliveryOptions.appendChild(title);

      var choices = document.createElement('div');
      choices.className = 'subscription-delivery-options__choices';
      deliveryOptions.appendChild(choices);
      controls.insertBefore(deliveryOptions, nativeFrequencyWrap || nativeSingleFrequency || null);
    }

    var choices = deliveryOptions.querySelector('.subscription-delivery-options__choices');
    choices.textContent = '';
    plans.forEach(function (plan) {
      var label = document.createElement('label');
      label.className = 'subscription-delivery-options__choice';

      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'subscription-delivery-frequency-' + deliveryGroupCounter;
      input.value = plan.planId;
      input.setAttribute('data-selling-plan-id', plan.planId);

      var text = document.createElement('span');
      text.textContent = plan.label;

      label.appendChild(input);
      label.appendChild(text);
      choices.appendChild(label);
    });

    var selectedOption = form.querySelector('.bulk-pricing-selling-plan-select option:checked');
    var selectedPlanInput = form.querySelector('.bulk-pricing-selling-plan-input');
    var selectedPlanId = selectedOption
      ? String(selectedOption.value)
      : selectedPlanInput &&
          (selectedPlanInput.getAttribute('data-single-plan-id') || selectedPlanInput.value);
    var selectedPlan = plans.find(function (plan) {
      return plan.planId === selectedPlanId;
    });
    var selectedCadence =
      (selectedPlan && selectedPlan.key) ||
      form.getAttribute('data-subscription-delivery-cadence') ||
      plans[0].key;
    if (
      !plans.some(function (plan) {
        return plan.key === selectedCadence;
      })
    ) {
      selectedCadence = (selectedPlan || plans[0]).key;
    }
    setDeliveryCadence(form, selectedPlan ? selectedPlan.planId : selectedCadence, false);

    // Default this PDP widget to Subscribe & Save once per rendered form.
    // The guard preserves any later Buy once selection made by the customer.
    if (form.getAttribute('data-subscription-default-option-set') !== 'true') {
      form.setAttribute('data-subscription-default-option-set', 'true');
      var subscriptionRadio = form.querySelector(
        'input[name="bulk-pricing-purchase-option"][value="subscription"]'
      );
      var onetimeRadio = form.querySelector(
        'input[name="bulk-pricing-purchase-option"][value="onetime"]'
      );

      if (subscriptionRadio && !subscriptionRadio.disabled) {
        if (onetimeRadio) onetimeRadio.checked = false;
        subscriptionRadio.checked = true;
        subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function ensureSubscriberOffer(form) {
    if (!form) return;

    var section = getTargetSection();
    if (!section) return;

    var rows = form.querySelectorAll(
      'bulk-pricing-table tbody .bulk-pricing-table__row, bulk-pricing-table tbody tr[data-qty]'
    );
    var offerCode = rows.length > 1 ? 'GLOVES5' : 'NEW5';
    var offer = section.querySelector('.subscription-subscriber-offer');

    if (!offer) {
      offer = document.createElement('div');
      offer.className = 'subscription-subscriber-offer';

      var banner = document.createElement('div');
      banner.className = 'subscription-subscriber-offer__banner';

      var icon = document.createElement('span');
      icon.className = 'subscription-subscriber-offer__icon';
      icon.setAttribute('aria-hidden', 'true');

      var headline = document.createElement('p');
      headline.className = 'subscription-subscriber-offer__headline';

      var copy = document.createElement('p');
      copy.className = 'subscription-subscriber-offer__copy';
      copy.textContent =
        'Save 20% on your first delivery, then enjoy 15% off every recurring order after. Cancel anytime.';

      banner.appendChild(icon);
      banner.appendChild(headline);
      offer.appendChild(banner);
      offer.appendChild(copy);
    }

    offer.setAttribute('data-offer-code', offerCode);
    var offerHeadline = offer.querySelector('.subscription-subscriber-offer__headline');
    if (offerHeadline) {
      offerHeadline.textContent =
        'New Subscriber Offer: Save 20% on your first delivery with code ' + offerCode;
    }

    var bulkBlock = form.closest('.shopify-block') || form;
    if (bulkBlock.nextElementSibling !== offer) {
      bulkBlock.insertAdjacentElement('afterend', offer);
    }
  }

  function updateSubscriberOffer(form, isSubscription) {
    if (!isProductSubscriptionTemplate()) return;
    var section = getTargetSection();
    if (!section) return;

    var offer = section.querySelector('.subscription-subscriber-offer');
    if (!offer) {
      ensureSubscriberOffer(form);
      offer = section.querySelector('.subscription-subscriber-offer');
    }
    if (!offer) return;

    offer.classList.toggle('subscription-subscriber-offer--onetime', !isSubscription);
    var copy = offer.querySelector('.subscription-subscriber-offer__copy');
    if (copy) {
      copy.textContent = isSubscription
        ? 'Save 20% on your first delivery, then enjoy 15% off every recurring order after. Cancel anytime.'
        : 'Subscribe instead to save 15% on every order \u2014 starting with 20% off your first delivery. Cancel anytime.';
    }
  }

  function decoratePurchaseOptionPricing(form) {
    if (!form) return;

    ensureDeliveryOptions(form);
    ensureSubscriberOffer(form);

    var cadence = form.querySelector('.bulk-pricing-selling-plan-single');
    if (cadence) {
      var cadenceText = (cadence.textContent || '').replace(/\s+/g, ' ').trim();
      var cadenceMatch = cadenceText.match(/Every\s+(.+)$/i);
      var cadenceValue = cadenceMatch ? cadenceMatch[1].trim().toLowerCase() : '1 month';
      cadence.setAttribute(
        'data-display-label',
        '\u21c4 Subscribe & Save \u2014 delivered every ' + cadenceValue
      );
    }

    var rows = form.querySelectorAll('bulk-pricing-table tbody .bulk-pricing-table__row');
    var isSingleTier = rows.length <= 1;
    form.classList.toggle('subscription-table--single', isSingleTier);
    var tableTitle = form.querySelector('.bulk-pricing-table__title');
    if (tableTitle && !tableTitle.hasAttribute('data-subscription-default-title')) {
      tableTitle.setAttribute(
        'data-subscription-default-title',
        (tableTitle.textContent || '').trim()
      );
    }
    if (tableTitle && isSingleTier) {
      tableTitle.textContent = 'Subscribe, Save More';
    }

    var headerCells = form.querySelectorAll(
      'bulk-pricing-table .bulk-pricing-table__header-cell'
    );
    if (headerCells[0]) {
      headerCells[0].textContent = isSingleTier ? 'Your subscription' : 'Quantity';
    }
    if (headerCells[1]) headerCells[1].textContent = 'Price';

    rows.forEach(function (row, index) {
      var quantityCell = row.querySelector('.bulk-pricing-table__cell:first-child');
      if (!quantityCell) return;

      if (isSingleTier) {
        quantityCell.textContent = 'Price per delivery';
      } else if (
        index === rows.length - 1 &&
        !quantityCell.querySelector('.subscription-best-price')
      ) {
        var bestPrice = document.createElement('span');
        bestPrice.className = 'subscription-best-price';
        bestPrice.textContent = 'Best price';
        quantityCell.appendChild(bestPrice);
      }
    });

    normalizeSubscriptionCurrency();
  }

  function placeBulkPricingWidget() {
    var section = getTargetSection();
    if (!section) return;

    var meta = section.querySelector('.subscription-pdp');
    if (!meta) return;

    var bulkBlock = meta.querySelector('.shopify-block:has(bulk-pricing-form), bulk-pricing-form');
    var chooseSize =
      meta.querySelector('.varqbtemplate:has(.kitcol.tttttttt)') ||
      meta.querySelector('.varqbtemplate.color-three-columns:has(.multiple-choice-size-grid)') ||
      meta.querySelector('.varqbtemplate:has(.multiple-choice-size-grid)') ||
      meta.querySelector('.varqbtemplate');

    if (!bulkBlock || !chooseSize || bulkBlock.previousElementSibling === chooseSize) return;
    bulkBlock.insertAdjacentElement('beforebegin', chooseSize);
  }

  function placeLoyaltyAfterPaymentForm() {
    var section = getTargetSection();
    if (!section) return;

    var blocks = section.querySelector('.subscription-pdp [data-product-blocks]');
    if (!blocks) return;

    var paymentBlock = Array.prototype.find.call(blocks.children, function (child) {
      return !!child.querySelector('form.product-single__form .payment-buttons');
    });
    if (!paymentBlock) return;

    var loyaltyBlocks = Array.prototype.filter.call(blocks.children, function (child) {
      return child.matches('.login-to-earn-points, .points-earned');
    });
    var insertionPoint = paymentBlock;

    loyaltyBlocks.forEach(function (loyaltyBlock) {
      if (insertionPoint.nextElementSibling !== loyaltyBlock) {
        insertionPoint.insertAdjacentElement('afterend', loyaltyBlock);
      }
      insertionPoint = loyaltyBlock;
    });
  }

  function syncThemeSellingPlan(form, isSubscription) {
    var section = getTargetSection();
    if (!section) return;
    var productForm = section.querySelector('.subscription-pdp form.product-single__form');
    if (!productForm) return;

    var appInput = form.querySelector('.bulk-pricing-selling-plan-input');
    var themeInput = productForm.querySelector('.subscription-selling-plan-input');
    var sellingPlanId = appInput
      ? appInput.getAttribute('data-single-plan-id') || appInput.value
      : '';

    if (!isSubscription || !sellingPlanId) {
      if (themeInput) themeInput.remove();
      return;
    }

    if (!themeInput) {
      themeInput = document.createElement('input');
      themeInput.type = 'hidden';
      themeInput.name = 'selling_plan';
      themeInput.className = 'subscription-selling-plan-input';
      productForm.appendChild(themeInput);
    }
    themeInput.value = sellingPlanId;
  }

  function updateSubscriptionCta(isSubscription) {
    var section = getTargetSection();
    if (!section) return;

    section.querySelectorAll('.subscription-pdp .add-to-cart').forEach(function (button) {
      var text = button.querySelector('[data-add-to-cart-text]');
      if (!text || button.disabled) return;

      button.classList.toggle('subscription-cta--subscribe', isSubscription);
      text.textContent = isSubscription
        ? 'Subscribe'
        : text.getAttribute('data-default-text') || 'Add to cart';
    });
  }

  function refreshFallbackTablePrices(form) {
    if (!form || typeof form.refreshTableDisplayedPrices === 'function') return;

    var isSubscription = getSelectedPurchaseOption(form) === 'subscription';
    var cadence = form.getAttribute('data-subscription-delivery-cadence');
    form.querySelectorAll('tr.bulk-pricing-table__row[data-tier-price]').forEach(function (row) {
      var priceCents = parseFloat(row.getAttribute('data-tier-price')) || 0;
      if (isSubscription && cadence) {
        var subscriptionPrice = parseFloat(
          row.getAttribute('data-tier-sub-' + cadence + '-price')
        );
        if (!isNaN(subscriptionPrice)) priceCents = subscriptionPrice;
      }

      var priceCell = row.querySelector('.bulk-pricing-table__cell:last-child');
      if (priceCell) priceCell.textContent = formatThemeMoney(priceCents);
    });
  }

  function updatePurchaseOptionUI(form) {
    if (!form) return;
    decoratePurchaseOptionPricing(form);
    var selected = getSelectedPurchaseOption(form);
    var isSubscription = selected === 'subscription';
    form.setAttribute('data-purchase-option', selected);
    form.classList.toggle('subscription-form--active', isSubscription);
    form.classList.toggle('subscription-form--onetime', !isSubscription);

    var section = getTargetSection();
    var useProductSubscriptionBuyOnceUI = isProductSubscriptionTemplate();
    if (section && useProductSubscriptionBuyOnceUI) {
      section.classList.toggle('subscription-purchase--active', isSubscription);
      section.classList.toggle('subscription-purchase--onetime', !isSubscription);
    } else if (section) {
      section.classList.remove('subscription-purchase--active', 'subscription-purchase--onetime');
    }
    if (useProductSubscriptionBuyOnceUI) updateSubscriberOffer(form, isSubscription);

    var tableTitle = form.querySelector('.bulk-pricing-table__title');
    if (tableTitle && useProductSubscriptionBuyOnceUI) {
      var hasSingleTier = form.classList.contains('subscription-table--single');
      var defaultTitle = tableTitle.getAttribute('data-subscription-default-title');
      tableTitle.textContent =
        !isSubscription || hasSingleTier
          ? 'Subscribe, Save More'
          : defaultTitle || 'Subscribe, Save More';
    }

    form.querySelectorAll('input[name="bulk-pricing-purchase-option"]').forEach(function (input) {
      var label = input.closest('label');
      if (!label) return;
      label.classList.toggle('is-selected', input.checked);
      label.setAttribute('aria-checked', input.checked ? 'true' : 'false');
    });

    // The app initializes this state on a full PDP load, but quick-view content is
    // injected after page load. Mirror the app state so the cadence banner and
    // subscription selling plan are both present when Subscribe is selected.
    var cadence = form.querySelector('.bulk-pricing-selling-plan-single');
    if (cadence) {
      cadence.style.setProperty('display', 'none', 'important');
    }

    var nativeFrequencyWrap = form.querySelector('.bulk-pricing-subscription-frequency-wrap');
    if (nativeFrequencyWrap) {
      nativeFrequencyWrap.style.setProperty('display', 'none', 'important');
    }

    var sellingPlanInput = form.querySelector('.bulk-pricing-selling-plan-input');
    if (sellingPlanInput) {
      if (isSubscription) {
        var sellingPlanId =
          sellingPlanInput.getAttribute('data-single-plan-id') || sellingPlanInput.value;
        if (sellingPlanId) sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true;
      }
    }
    syncThemeSellingPlan(form, isSubscription);
    updateSubscriptionCta(isSubscription);
    refreshFallbackTablePrices(form);
  }

  /** After Buy once / Subscribe change: refresh prices + theme qty/total */
  function syncAfterPurchaseOptionChange() {
    var form = getBulkForm();
    if (!form) return;

    updatePurchaseOptionUI(form);

    // Ensure app redraws table prices for the selected mode
    if (typeof form.refreshTableDisplayedPrices === 'function') {
      form.refreshTableDisplayedPrices();
    }
    if (typeof form.updatePriceFromInput === 'function') {
      var themeQty = getThemeQtyInput();
      var qty = themeQty ? parseInt(themeQty.value, 10) || 1 : form.quantity || 1;
      form.quantity = qty;
      form.updatePriceFromInput(qty);
    }
    if (typeof form.updateText === 'function') {
      form.updateText();
    }

    var activeRow = getActiveRow(form);
    if (!activeRow) return;

    var themeQtyInput = getThemeQtyInput();
    var qty = themeQtyInput
      ? parseInt(themeQtyInput.value, 10) || 1
      : parseInt(activeRow.getAttribute('data-qty'), 10) || 1;
    var unitCents = getEffectiveUnitCents(activeRow, form);

    updateThemeTotal(qty, unitCents);
    updateThemeSavings(qty, unitCents, form);
    window.setTimeout(function () {
      var row = getActiveRow(form);
      var cents = getEffectiveUnitCents(row, form);
      updateThemeTotal(qty, cents);
      updateThemeSavings(qty, cents, form);
    }, 50);
    window.setTimeout(function () {
      var row = getActiveRow(form);
      var cents = getEffectiveUnitCents(row, form);
      updateThemeTotal(qty, cents);
      updateThemeSavings(qty, cents, form);
    }, 200);
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // In quick view Shopify injects the app markup after the collection page
    // has loaded, so the app's custom elements may remain unupgraded. Keep row
    // selection functional and mirror the same quantity/price state ourselves.
    var pricingRow = target.closest(
      'bulk-pricing-table tbody tr.bulk-pricing-table__row[data-qty]'
    );
    if (pricingRow) {
      var pricingForm = pricingRow.closest('bulk-pricing-form');
      if (!pricingForm || pricingForm !== getBulkForm()) return;

      var selectedQty = parseInt(pricingRow.getAttribute('data-qty'), 10) || 1;
      pricingForm
        .querySelectorAll('tr.bulk-pricing-table__row--active')
        .forEach(function (row) {
          row.classList.remove('bulk-pricing-table__row--active');
        });
      pricingRow.classList.add('bulk-pricing-table__row--active');

      var appQty = getAppQtyInput(pricingForm);
      if (appQty) {
        appQty.value = String(selectedQty);
        appQty.dispatchEvent(new Event('input', { bubbles: true }));
        appQty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      pricingForm.quantity = selectedQty;
      var pricingTable = pricingForm.querySelector('bulk-pricing-table');
      if (pricingTable && typeof pricingTable.updateActiveRow === 'function') {
        pricingTable.updateActiveRow(selectedQty);
      }
      if (typeof pricingForm.updatePriceFromInput === 'function') {
        pricingForm.updatePriceFromInput(selectedQty);
      }
      if (typeof pricingForm.updateText === 'function') {
        pricingForm.updateText();
      }

      syncThemeFromRow(pricingRow);
      return;
    }

    if (target.closest('.flxwrap__qty .js-qty__adjust, .flxwrap__qty .qty-input-plus, .flxwrap__qty .qty-input-minus')) {
      window.setTimeout(syncFromThemeQuantity, 40);
      return;
    }

    // Purchase option label/radio click (exclusive Buy once | Subscribe)
    if (
      target.closest('input[name="bulk-pricing-purchase-option"]') ||
      target.closest('.bulk-pricing-subscription-controls label') ||
      target.matches?.('input[name="bulk-pricing-purchase-option"]')
    ) {
      window.setTimeout(syncAfterPurchaseOptionChange, 30);
      window.setTimeout(syncAfterPurchaseOptionChange, 150);
      window.setTimeout(syncAfterPurchaseOptionChange, 350);
    }
  }

  function onQtyInput(event) {
    if (!event.target) return;
    if (!event.target.matches) return;
    if (!event.target.matches('.flxwrap__qty .sliderqty, .flxwrap__qty .js-qty__num')) return;
    window.setTimeout(syncFromThemeQuantity, 30);
  }

  function onPurchaseOptionChange(event) {
    if (
      event.target &&
      event.target.name &&
      event.target.name.indexOf('subscription-delivery-frequency-') === 0
    ) {
      var deliveryForm = event.target.closest('bulk-pricing-form');
      if (!deliveryForm) return;

      // The delivery plans share the same tier schedule. Update the selected
      // selling-plan IDs directly instead of dispatching the app select's
      // change event, which unnecessarily redraws the table and resets tier 1.
      setDeliveryCadence(deliveryForm, event.target.value, false);
      syncThemeSellingPlan(deliveryForm, true);
      refreshFallbackTablePrices(deliveryForm);
      var selectedDeliveryRow = getActiveRow(deliveryForm);
      if (selectedDeliveryRow) syncThemeFromRow(selectedDeliveryRow);
      return;
    }
    if (!event.target || event.target.name !== 'bulk-pricing-purchase-option') return;
    syncAfterPurchaseOptionChange();
  }

  function initialSync() {
    placeBulkPricingWidget();
    placeLoyaltyAfterPaymentForm();
    var form = getBulkForm();
    updatePurchaseOptionUI(form);
    var activeRow = getActiveRow(form);
    if (activeRow) {
      syncThemeFromRow(activeRow);
    }
    normalizeSubscriptionCurrency();
  }

  function init() {
    if (initialized) return;
    if (!isTargetTemplate()) return;
    if (!getBulkForm()) return;

    initialized = true;

    document.addEventListener('pricing-table-select', onPricingTableSelect);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('input', onQtyInput);
    document.addEventListener('change', onQtyInput);
    document.addEventListener('change', onPurchaseOptionChange);
    document.addEventListener('variant:change', function () {
      window.setTimeout(initialSync, 100);
    });

    // App / Seal may finish rendering after first paint
    window.setTimeout(initialSync, 300);
    window.setTimeout(initialSync, 1000);
    window.setTimeout(initialSync, 2500);
  }

  function syncQuickviewTemplateClass(event) {
    if (bodyHasNativeTargetTemplate || !document.body) return;

    var productId = event && event.detail ? event.detail.productId : null;
    var section = getTargetSection(productId);
    var isTargetQuickview = !!section;
    var productTemplate = section
      ? section.getAttribute('data-product-template')
      : null;
    activeTargetProductId = isTargetQuickview ? productId : null;
    document.body.classList.toggle(TARGET_TEMPLATE_CLASS, isTargetQuickview);
    TARGET_PRODUCT_TEMPLATE_CLASSES.forEach(function (templateClass) {
      document.body.classList.toggle(
        templateClass,
        isTargetQuickview && productTemplate === templateClass
      );
    });
  }

  document.addEventListener('quickview:open', function (event) {
    syncQuickviewTemplateClass(event);
  });

  document.addEventListener('quickview:loaded', function (event) {
    syncQuickviewTemplateClass(event);
    if (!isTargetTemplate()) return;
    placeBulkPricingWidget();
    init();
    window.setTimeout(initialSync, 50);
    window.setTimeout(initialSync, 300);
  });

  document.addEventListener('quickview:close', function () {
    if (bodyHasNativeTargetTemplate || !document.body) return;
    activeTargetProductId = null;
    document.body.classList.remove(TARGET_TEMPLATE_CLASS);
    TARGET_PRODUCT_TEMPLATE_CLASSES.forEach(function (templateClass) {
      document.body.classList.remove(templateClass);
    });
  });

  function boot() {
    ensureSubscriptionTemplateClass();
    bodyHasNativeTargetTemplate =
      !!document.body &&
      document.body.classList.contains(TARGET_TEMPLATE_CLASS);
    init();
    // App block can mount late
    var observer = new MutationObserver(function () {
      if (!initialized && getBulkForm()) {
        init();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
